<template>
  <FeaturesComponent />
</template>

<script>
// @ is an alias to /src
import FeaturesComponent from "@/components/Features/Features.vue";
export default {
  name: "Features",
  components: {
    FeaturesComponent
  }
};
</script>
